/**
 * @generated SignedSource<<bf66fa80a83737662f3c4b41a3635857>>
 * @relayHash f4c18416589b411794a30898aae2bd16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d66d8875dee6114e801f2c79b2f818022a23c69b3c7284d27e597d6411ceb39a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentImageBgQuery } from './PopupContentImageBgQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentImageBgQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d66d8875dee6114e801f2c79b2f818022a23c69b3c7284d27e597d6411ceb39a",
    "metadata": {},
    "name": "PopupContentImageBgQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
